export default "__VITE_ASSET__535ada76__"